// extracted by mini-css-extract-plugin
module.exports = {"personalInf":"personalInf","colBox":"colBox","nameBox":"nameBox","groupBox":"groupBox","c7n-card-body":"c7n-card-body"};